export const VERSION = '3.10.0';
export const CONTAINER_WIDTH = 614;
export const CONTAINER_HEIGHT = 334;
export const initial = CONTAINER_HEIGHT / 2;

export type Values = {
  cameraHeight?: number;
  cameraOffset?: number;
  vehicleWidth?: number;
  lowestUsableRow: number;
  calpickTopLeftCol: number;
  calpickTopLeftRow: number;
  calpickBottomLeftCol: number;
  calpickBottomLeftRow: number;
  calpickTopRightCol: number;
  calpickTopRightRow: number;
  calpickBottomRightCol: number;
  calpickBottomRightRow: number;
};
export type UrlParams = {
  deviceImei: string,
  orgId: string
};

export const DEVICE_STATUSES = {
  ONLINE: 'online',
  OFFLINE: 'offline',
  STAND_BY: 'standby',
} as const;

export type Coordinates = {
  xPosition: number;
  yPosition: number;
};
